export default "__VITE_ASSET__CM28$lqi__"